<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>留言列表</span>
        <!-- <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/message/create')"
          >创建留言</el-button
        > -->
      </div>

      <el-row>
        <el-col :span="5">
          <el-input
            placeholder="请输入留言人"
            v-model="queryParams.name"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
        <!-- <el-col :span="4">
          <el-select
            v-model="queryParams.type"
            placeholder="类型"
            @change="radioChange($event, 'type')"
            clearable
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col> -->
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="dictList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeDict"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import { pageList, deleteMessage, updateMessage } from '@/api/message'
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    TzTable,
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      dictTypeValue: '',
      editState: false,
      editUnit: {},
      dictList: [],
      radioStatus: null, // 1是;2否
      queryParams: {
        pageSize: '10',
        pageNum: 1,
        name: null
        // pushMp: null,
        // pushMpFlag: null,
        // pushOfficialWebsite: null,
        // pushOfficialWebsiteFlag: null
      },
      radioOptions: [
        { value: 1, label: '是' },
        { value: 2, label: '否' }
      ],
      typeOptions: [
        { value: 1, label: '轮播图' },
        { value: 2, label: 'logo' }
      ],
      columns: [
        {
          field: 'name',
          title: '留言人'
        },
        {
          field: 'content',
          title: '内容'
        },
        {
          field: 'phone',
          title: '手机号'
        },
        {
          field: 'remark',
          title: '备注'
        },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '备注',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                this.editUnit = JSON.parse(JSON.stringify(row))
                // // 显示弹框
                this.editState = true
                // this.$router.push({
                //   path: '/banner/Create',
                //   query: { id: row.id }
                // })
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.getDictList()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getDictList()
    },
    // 列表
    getDictList() {
      // this.$loading({
      //   text: '查询中'
      // })

      pageList(this.queryParams).then((res) => {
        if (res.code == 200) {
          // this.$loading().close()

          let dictArr = res.data.records
          this.total = res.data.total

          this.dictList = dictArr
        }
        // else {
        //   this.$loading().close()
        // }
      })
    },

    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteMessage(delparams).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getDictList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 编辑
    changeDict(infos) {
      console.log(infos)
      this.$loading({
        text: '保存中...'
      })
      let updateparams = {
        ...infos
        // id: infos.id,
        // title: infos.title,
        // content: infos.content,
        // thumbnail: infos.thumbnail,
        // mpUrl: infos.mpUrl,
        // status: infos.status
      }
      updateMessage(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.getDictList()
        } else {
          this.$message({
            type: 'error',
            message: '保存失败!'
          })
        }
        this.editState = false
      })
      setTimeout(() => {
        this.$loading().close()
      }, 1000)
    },
    // 模糊查询
    dictSearch() {
      this.queryParams.pageNum = 1
      this.getDictList()
    },
    // radio选择
    radioChange(el, type) {
      console.log(el, '当前选择')
      this.queryParams.pageNum = 1
      this.queryParams[type] = el
      this.getDictList()
    }
  },
  mounted() {
    this.getDictList()
  }
}
</script>

<style></style>
